import React from 'react';
import { useSelector } from 'react-redux';
import { Checkbox, ICheckbox } from '../components/Checkbox';
import { IOnOffProp, OnOff } from '../components/OnOff';
import { RootState, store } from '../store';
import { FilterWrapTempl } from './FilterWrapTempl';

export const FilterWrapL2m = () => {
    const l10n = useSelector((state: RootState) => state.main.l10n);
    const config = store.getState().main.config;

    const gradeCheckProp: ICheckbox = {
        l10n: l10n,
        config: config,
        title: '등급',
        watch: 'grades',
        cls: 'grades',
        resetObj: { page: '1', fromitemid: '' },
        path: `/${config.service}/v2.0/game/collection/grade`,
        ga360str: '컬렉션_조건검색_등급_클릭',
        submitCallback: (_d) => {},
    };

    const onoffProp: IOnOffProp = {
        l10n: l10n,
        watch: 'incomplete',
        title: '완료 여부',
        description: `미완료 컬렉션만 보기`,
        resetObj: { page: '1', fromitemid: '' },
        initVal: (!!window.userData.gameAccount.serverId).toString(),
        ga360str: '컬렉션_조건검색_완료여부_클릭',
        submitCallback: (_d) => {},
    };

    const optionCheckProp: ICheckbox = {
        l10n: l10n,
        config: config,
        title: '옵션',
        watch: 'options',
        cls: 'options',
        resetObj: { page: '1', fromitemid: '' },
        path: `/${config.service}/v2.0/game/collection/option`,
        ga360str: '컬렉션_조건검색_옵션_클릭',
        submitCallback: (_d) => {},
    };

    const refObj = {
        grades: '',
        incomplete: '',
        options: '',
        fromitemid: '',
        page: '1',
    };

    return (
        <FilterWrapTempl refreshObj={refObj}>
            <>
                <Checkbox props={gradeCheckProp} />
                <OnOff props={onoffProp} />
                <Checkbox props={optionCheckProp} />
            </>
        </FilterWrapTempl>
    );
};
